@if (training == null || user == null || labels == null || test == null) {
  <app-user-spinner></app-user-spinner>
}
<div class="row">
  <div class="container2 col-xl-6 col-sm-5" style="margin: auto;">
    <div class="testHeader font" style = "margin-top: 3%;">
      <div class = "testQuestion" style = "line-height: 120%; margin-top: 0px;">
        {{test.name}}
      </div>
    </div>
    <div>
      @if (textQuestionAvailable) {
        <div class="testQuestion font" style = "padding-top: 10px">
          <!--<h5 class = "font" style = "font-size: 15px; margin-bottom: 7%;">{{labels.lblQuestionCapsLock}} {{test.questions[index].order}} {{labels.lblOfCL}} {{test.questions.length}}</h5>-->
          <h3 class="questionText font" style="line-height: 40px;">
            <span style="font-weight: bold;">{{test.questions[index].text}}</span>
          </h3>
          @if (test.questions[index].imagePath) {
            <div style="width: 100%; text-align: center; background: black; height: 200px;">
              <img style="width:100%; height: 100%; margin: auto; object-fit: contain;" src = {{test.questions[index].imagePath}} alt = "test question image">
            </div>
          }
          <!-- <h4 *ngIf="test.questions[index].type==2"><span style="color:rgb(241,106,100);">*Ovo pitanje ima više tačnih odgovora</span></h4> -->
          @for (answer of test.questions[index].answers; track answer) {
            <div class="answer" [class.answerSelectedEMS]='answer.selected && (user.companyId == 1)' [class.answerSelectedECG]='answer.selected && (user.companyId != 1)'>
              <!-- <input type="checkbox" id="{{answer.id}}" [(ngModel)]="answer.selected" (change)="onSelect(test.questions[index], answer);"/> {{answer.text}} -->
              <mat-checkbox [value]="answer" class="checkBox " [(ngModel)]="answer.selected" (change)="onSelect(test.questions[index], answer);">
                <span style="font-size: 2.3vh; font-weight: bold; white-space: break-spaces; letter-spacing: 1px;">{{answer.text}}</span>
              </mat-checkbox>
            </div>
          }
          @if (test.questions[index].type == 3) {
            <div class="answer" style="border: 1px solid transparent">
                        <textarea
                          matInput
                          [ngModel]="txtAnswer"
                          required
                          placeholder="{{labels.lblTypeYourAnswerHere}}"
                          name = "textAnswer"
                          style="width: 100%; min-height: 50px; background: #23272f; color: #fff; border: 1px solid #444; border-radius: 8px; padding: 12px; font-size: 1rem; outline: none; resize: vertical;"
                          (change) = "changeInput($event)"
                          (keyup) = "onTextInput($event)"></textarea>
            </div>
          }
        </div>
      } @else {
        <div style="display: flex;" class="justify-content-center align-items-center">
          <div>
            <div class="testQuestion font" style = "padding-top: 10px">
              <!--<h5 class = "font" style = "font-size: 15px; margin-bottom: 7%;">{{labels.lblQuestionCapsLock}} {{test.questions[index].order}} {{labels.lblOfCL}} {{test.questions.length}}</h5>-->
              <h3 class="questionText font" style="line-height: 40px; font-size:48px; text-align: center">
                <span style="font-weight: bold;">{{test.questions[index].text}}</span>
              </h3>
            </div>
            <h3 class="questionText font" style="line-height: 40px;">
              <span style="font-weight: bold; font-size: 52px">{{labels.lblDidYouFinishedTask}}</span>
            </h3>
            <div class="row my-5">
              <div class="col-12">
                <button mat-raised-button class="button" style="font-size: 50px; height: 80px; width: 160px"
                        (click)="toggleTextQuestionAvailable(true)">
                  {{labels.lblYes}}
                </button>
                <button mat-raised-button class="button"  style="font-size: 50px; height: 80px; width: 160px; float: right"
                        (click)="voidUserTraining()">
                  {{labels.lblNoButton}}
                </button>
              </div>
            </div>
          </div>

        </div>

      }

    </div>
  </div>

  @if (textQuestionAvailable) {
    <div class = "col-xl-7 col-sm-3" style = "position: relative; height: 80px; margin: auto;">
      <button id="goBack" mat-raised-button class="button" style="float: left;"
              (click)="toggleTextQuestionAvailable(false)">
        <img src = "./assets/icons/backIconNavy.png" alt = "Back icon image">
        <span style = "vertical-align: middle; padding-left: 11px;">{{labels.lblBack}}</span>
      </button>
      <!--@if (!(index==0)) {
        <button mat-raised-button class="button mx-2" [class]="buttons" style="float: left;" *ngIf="!(index==0)"
                (click)="previousQuestion(test.questions[index].order)">
          {{labels.lblPreviousTask}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: #0E0D35;">arrow_back</mat-icon>
        </button>
      }-->

      <div class="buttons" style = "position: absolute; right: 7%; bottom: 10;">
        @if ((!(index==test.questions.length-1) && (showNextBtn == true))) {
          <button mat-raised-button class="button"
                  (click)="nextQuestion(test.questions[index].order)">
            {{labels.lblSubmit}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: #0E0D35;">arrow_forward</mat-icon>
          </button>
          <!--<img style = "cursor: pointer;" (click)="nextQuestion(test.questions[index].order)" src = 'https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/testBtnNext.png?alt=media&token=51cd63ca-4837-406c-bfe6-9eceb70a0994' alt = "button image">-->
        }
        @if ((!(index==test.questions.length-1) && (showNextBtn == false))) {
          <img class = "btnDisabled"  src = 'https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/testBtnNext.png?alt=media&token=51cd63ca-4837-406c-bfe6-9eceb70a0994' alt = "disabled button image">
        }

        @if ((index==test.questions.length-1 && (showNextBtn == true))) {
          <button mat-raised-button class="button"
                  (click)="submit(test.questions[index].order, false)">
            {{labels.lblSubmit}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: #0E0D35;">arrow_forward</mat-icon>
          </button>
        }
      </div>
    </div>
  }

<div class = "row">
  <div class="col-12 progress" style = "left: 0" [style.width]="testProgress+'%'"></div>
</div>
</div>

<!-- mobile -->
<div class="mobileContainer row">
  <div class="container2 col-xs-12">
    <div class="testHeader font">
      {{test.name}}
    </div>
    <div class="testQuestion">
      <h5 class = "font" style = "font-size: 15px;">{{labels.lblQuestionCapsLock}} {{test.questions[index].order}} {{labels.lblOfCL}} {{test.questions.length}}</h5>
      <h3 class="questionText">
        <span style="font-weight: bold; line-height: 35px;">{{test.questions[index].text}}</span>
      </h3>
      @if (test.questions[index].imagePath) {
        <div style="width: 300px; text-align: center; background: black; height: 200px;">
          <img style="width:100%; height: 100%; margin: auto; object-fit: contain;" src = {{test.questions[index].imagePath}}>
        </div>
      }
      <!-- <h4 *ngIf="test.questions[index].type==2"><span style="color:rgb(241,106,100);">*Ovo pitanje ima više tačnih odgovora</span></h4> -->
      @for (answer of test.questions[index].answers; track answer) {
        <div class="answer" [class.answerSelectedEMS]='answer.selected && (user.companyId == 1)' [class.answerSelectedECG]='answer.selected && (user.companyId != 1)'>
          <!-- <input type="checkbox" id="{{answer.id}}" [(ngModel)]="answer.selected" (change)="onSelect(test.questions[index], answer);"/> {{answer.text}} -->
          <mat-checkbox [value]="answer" class="checkBox " [(ngModel)]="answer.selected" (change)="onSelect(test.questions[index], answer);">
            <span style="font-size: 2vh; font-weight: bold; white-space: pre-line;">{{answer.text}}</span>
          </mat-checkbox>
        </div>
      }
      @if (test.questions[index].type == 3) {
        <div class="answer">
          <textarea style="width: 100%; background-color: #f4f8f9; outline: none; border-radius: 5px; color: #0E0D35;" matInput ngModel required name = "textAnswer" (change) = "changeInput($event)" (keyup) = "onTextInput()"></textarea>
        </div>
      }
    </div>
    <div class="buttons" style = "margin-right: 15px; text-align: right;">
      <button id="goBack" mat-raised-button class="button" style="float: left;"
              (click)="goToTrainingDetails(training)">
        <img src = "./assets/icons/backIconNavy.png" alt = "Back icon image">
        <span style = "vertical-align: middle; padding-left: 11px;">{{labels.lblBack}} {{training.name}}</span>
      </button>
      <!-- <button mat-raised-button class="button" [class] = "buttons" style="float: left;" *ngIf="!(index==0)"
      (click)="previousQuestion(test.questions[index].order)">
      {{labels.lblBack}}
    </button> -->


    @if ((!(index==test.questions.length-1) && (showNextBtn == true))) {
      <img style = "cursor: pointer;" (click)="nextQuestion(test.questions[index].order)" src = 'https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/testBtnNext.png?alt=media&token=51cd63ca-4837-406c-bfe6-9eceb70a0994'>
    }
    @if ((!(index==test.questions.length-1) && (showNextBtn == false))) {
      <img class = "btnDisabled"  src = 'https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/testBtnNext.png?alt=media&token=51cd63ca-4837-406c-bfe6-9eceb70a0994'>
    }

    @if ((index==test.questions.length-1 && (showNextBtn == true))) {
      <button mat-raised-button class="button"
        (click)="submit(test.questions[index].order, false)">
        {{labels.lblSubmit}} <mat-icon style = "vertical-align: middle; margin-left: 15px; color: white;">arrow_forward</mat-icon>
      </button>
    }
  </div>
</div>
<div class = "col-12" class="progress" [style.width]="testProgress+'%'"></div>
</div>
